export default {
  BASE: "Base game",
  FORGOTTEN_CIRCLES: "Forgotten Circles",
  JAWS_OF_THE_LION: "Jaws of the Lion",
  SOLO: "Solo",
  KICKSTARTER: "Kickstarter",
};



// WEBPACK FOOTER //
// ./src/constants/ExpansionConstants.js